/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for granting an entitlement after a user returns from Stripe checkout.
 *
 * Carries the Stripe Checkout Session id from the success redirect.
 */
export interface CheckoutSuccessRequest {
  /** Stripe Checkout Session id from the success redirect. */
  session_id: string;
}
